export const getNameLetter = (email = "") => {
    const username = email.split("@")[0];
    const initials = username
        .split(".")
        .map((name) => name[0].toUpperCase())
        .join("");
    return initials;
};

export const stringToColor = (string = "") => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
};
